<template>
    <div>
        <div class="row">
            <div class="page-header">
                <div class="d-flex align-items-center">

                    <h2 class="page-header-title">
                        <router-link to="/fire-stopping-reports">
                        Fire Stopping Reports</router-link>
                        &raquo;
                        <router-link :to="{ name: 'fire-stopping-report-view', params: {action: 'view', id: fireStoppingReport.site_fire_stopping_report_id} }">
                            {{ fireStoppingReport.job_number }} | {{ fireStoppingReport.prepared_for }}
                        </router-link>
                        &raquo;
                        <span v-if="isEdit">Edit</span><span v-else>Add</span> Site Plan</h2>
                </div>
            </div>
        </div>

        <form @submit.prevent="submit">
            <div class="form-body">
                <div style="display:none;">
                    <div class="col-lg-6 col-md-12"><input type="hidden" name="_method" value="POST"/></div>
                </div>
                <div class="form-body">
                    <input
                            name="site_fire_stopping_report_id"
                            type="hidden"
                            v-model="sitePlan.site_fire_stopping_report_id"
                    >
                    <input
                            name="site_fire_stopping_report_site_plan_id"
                            type="hidden"
                            v-model="sitePlan.site_fire_stopping_report_site_plan_id"
                    >
                    <div class="row">
                        <div class="col-sm-12 widget-20">
                            <div class="widget has-shadow">
                                <div class="widget-header bordered d-flex align-items-center section-header">
                                    <h2>Site Plan Details</h2>
                                </div>
                                <div class="widget-body">

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('site_plan_title')]"
                                                for="site_plan_title">
                                            Site Plan Title
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="site_plan_title"
                                                    id="site_plan_title"
                                                    :class="['form-control', getFieldClasses('site_plan_title')]"
                                                    v-model="sitePlan.site_plan_title"
                                                    type="text"
                                                    maxlength="255"
                                                    class="form-control"
                                                    @blur="onFieldBlur('site_plan_title')"
                                            />
                                            <div v-if="isErrorField('site_plan_title')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            Site Plan Image
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <div v-if="sitePlan.offline_site_plan_image != null">
                                                <img v-bind:src="sitePlan.offline_site_plan_image.data" class="img-fluid">
                                            </div>
                                            <div v-else-if="sitePlan.site_plan_image != null">
                                                <img v-bind:src="this.cmsUrl + sitePlan.site_plan_image" class="img-fluid">
                                            </div>
                                            <div class="pt-2">
                                                <div v-if="addingSitePlanImage">
                                                    <div v-if="isImageUploading" style="background: #eaeaea; padding: 10px; margin: 10px 0;">
                                                        <h3><span class="fa fa-spin fa-circle-notch"></span>
                                                            Adding image... Please wait...</h3>
                                                    </div>
                                                    <label class="fileContainer">
                                                        <span class="fa fa-camera"></span> Click to add an image
                                                        <input type="file" accept="image/*" @change="onFileChange">
                                                    </label>
                                                </div>
                                                <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                    href="javascript:void(0)"
                                                    v-on:click="addSitePlanImage"
                                                ><span v-if="sitePlan.offline_site_plan_image != null || sitePlan.site_plan_image != null">Replace</span><span v-else>Add</span> photo</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="alert alert-danger" v-if="isError">
                                        <p class="mb-0">
                                            <strong>The following fields have errors or are missing:</strong>
                                        </p>
                                        <ul class="mb-0 pl-3" v-if="errors.length > 0">
                                            <li v-for="error in errors" v-bind:key="error.field">
                                                <span v-if="error.field">{{ 'form.'+error.field }}<span v-if="error.message">: error.message</span></span>
                                                <span v-else-if="error.message">error.message</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">

                            <div class="form-group">
                                <button type="submit" class="btn btn-primary btn-square btn-lg w-100" :disabled="submitting">
                                    <span v-if="submitting">Submitting... <i class="fa fa-circle-notch fa-spin"></i></span>
                                    <span v-else>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>



    </div>
</template>


<script>

    import { required } from 'vuelidate/lib/validators'
    import ImageRotate from '@/components/mixins/ImageRotate.js'
    import moment from 'moment'

    var Compress = require('compress.js');
    var EXIF = require('exif-js');

    export default {
        mixins: [ImageRotate],
        data() {
            return {
                addingSitePlanImage: false,
                isImageUploading: false,
                isEdit: false,
                isSubmitted: false,
                isError: false,
                errorHeader: 'error.invalidFields',
                errors: [],
                submitting: false,
                sitePlan: {
                    fire_stopping_site_plan_id: null,
                    site_fire_stopping_report_site_plan_id: Math.floor(new Date().getTime() / 1000),
                    fire_stopping_report_id: null,
                    site_fire_stopping_report_id: null,
                    site_plan_title: null,
                    site_plan_image: null,
                    user_id: null,
                    offline_site_plan_image: null
                },
                fireStoppingReport: {
                    fire_stopping_report_id: null,
                    job_number: 'Loading...',
                    prepared_for: 'Please wait...',
                    site_fire_stopping_report_id: this.isEdit ? null : this.$route.params.id,
                }
            }
        },
        validations: {
            sitePlan: {
                site_plan_title: { required },
                site_plan_image: {
                    isImageSet(value) {
                        if (value) {
                            return true;
                        }

                        return this.sitePlan.offline_site_plan_image;
                    }
                }
            },
        },
        components: {
        },
        methods: {
            addSitePlanImage() {
                this.addingSitePlanImage = true;
            },
            onFileChange(e) {
                this.isImageUploading = true;
                var files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    this.isImageUploading = false;
                    return;
                }
                var vm = this;
                EXIF.getData(files[0], function() {
                    var orientation = EXIF.getTag(this, "Orientation");
                    vm.createImage(files[0], orientation);
                });
            },
            createImage(file, orientation) {
                var compress = new Compress()
                var files = [file]
                var vm = this;
                compress.compress(files, {
                    size: 4, // the max size in MB, defaults to 2MB
                    quality: .8, // the quality of the image, max is 1,
                    maxWidth: 1920, // the max width of the output image, defaults to 1920px
                    maxHeight: 1920, // the max height of the output image, defaults to 1920px
                    resize: true, // defaults to true, set false if you do not want to resize the image width and height
                }).then(async (data) => {
                    var imgSrc = data[0].prefix + data[0].data;
                    var rotationDegrees = 0;
                    switch(orientation) {
                        case 3:
                            rotationDegrees = 180;
                            break;
                        case 6:
                            rotationDegrees = -90;
                            break;
                        case 8:
                            rotationDegrees = 90;
                            break;    
                    }

                    if(rotationDegrees != 0) {
                        await this.rotateImage(imgSrc, rotationDegrees).then(newDataUri => {
                            console.log('Image rotated');
                            imgSrc = newDataUri;
                        }).catch(e => {
                            console.log(e);
                        });
                    }

                    console.log('Image added to array');
                    this.sitePlan.offline_site_plan_image = {
                        'data': imgSrc, 
                        'alt': data[0].alt, 
                        'orientation': orientation
                    };
                    this.isImageUploading = false;
                    this.addingSitePlanImage = false;
                });
            },
            getSitePlan() {
                var vm = this;
                this.getDb(function onConnectedDb(db) {
                    try {
                        var sitePlanId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('fire_stopping_report_site_plans').objectStore('fire_stopping_report_site_plans');
                        var storeRequest = objectStore.get(sitePlanId);
                        storeRequest.onsuccess = function(event) {
                            vm.sitePlan = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.getFireStoppingReport();
                            }
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getFireStoppingReport() {
                var vm = this;
                this.getDb(function onConnectedDb(db) {
                    try {
                        var reportId = vm.isEdit ? vm.sitePlan.site_fire_stopping_report_id : parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('fire_stopping_reports').objectStore('fire_stopping_reports');
                        var storeRequest = objectStore.get(reportId);
                        storeRequest.onsuccess = function(event) {
                            vm.fireStoppingReport = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                //console.log(vm.fireStoppingReport);
                                vm.sitePlan.site_fire_stopping_report_id = vm.fireStoppingReport.site_fire_stopping_report_id;
                                vm.sitePlan.fire_stopping_report_id = vm.fireStoppingReport.fire_stopping_report_id;
                            }
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.sendFormData();
                } else {
                    this.validationError();
                }
            },
            enableSubmitLoader() {
                this.submitting = true;
            },
            disableSubmitLoader() {
                this.submitting = false;
            },
            sendFormData() {
                this.enableSubmitLoader();

                var vmt = this;
                this.getDb(function onConnectedDb(db) {

                    var putRequest = db.transaction('fire_stopping_report_site_plans', 'readwrite')
                        .objectStore('fire_stopping_report_site_plans').put({
                            fire_stopping_report_site_plan_id: vmt.sitePlan['fire_stopping_report_site_plan_id'],
                            site_fire_stopping_report_site_plan_id: vmt.sitePlan['site_fire_stopping_report_site_plan_id'],
                            fire_stopping_report_id: vmt.sitePlan['fire_stopping_report_id'],
                            site_fire_stopping_report_id: vmt.sitePlan['site_fire_stopping_report_id'],
                            site_plan_title: vmt.sitePlan['site_plan_title'],
                            site_plan_image: vmt.sitePlan['site_plan_image'],
                            user_id: vmt.$session.get('user_id'),
                            offline_site_plan_image: vmt.sitePlan['offline_site_plan_image']
                        });
                    putRequest.onsuccess = function(event) {
                        vmt.submitSuccess({
                            success: true,
                            site_fire_stopping_report_site_plan_id: putRequest.result,
                        })
                    }
                    putRequest.onerror = function(event) {
                        alert("Unable to add data ");
                    };
                })

            },
            submitSuccess(response) {
                if (response.success) {
                    this.isSubmitted = true;
                    this.isError = false;
                    this.$router.push({ name: 'fire-stopping-report-view-site-plan', params: {id: response.site_fire_stopping_report_site_plan_id} })
                } else {
                    this.errorHeader = 'error.invalidFields';
                    this.errors = response.data.errors;
                    this.isError = true;
                }
            },
            submitError(error) {
                this.errorHeader = 'error.general';
                this.errors = [{'field': null, 'message': 'error.generalMessage'}];
                this.isError = true;
            },
            validationError() {
                this.errorHeader = 'error.invalidFields';
                this.errors = this.getErrors();
                this.isError = true;
            },
            isErrorField(field) {
                try {
                    if (this.getValidationField(field).$error) {
                        return true;
                    }
                } catch (error) {}

                return this.errors.some(el => el.field === field);
            },
            getErrors() {
                let errors = [];
                for (var field of Object.keys(this.sitePlan)) {
                    try {
                        if (this.getValidationField(field).$error) {
                            errors.push({'field': field, 'message': null});
                        }
                    } catch (error) {}
                }
                return errors;
            },
            getFieldClasses(field) {
                return { 'is-invalid': this.isErrorField(field) }
            },
            getContainerClasses(field) {
                return { 'text-danger': this.isErrorField(field) }
            },
            getValidationField(field) {
                if (this.$v.sitePlan[field]) {
                    return this.$v.sitePlan[field];
                }
                throw Error('No validation for field ' + field);
            },
            onFieldBlur(field) {
                try {
                    this.getValidationField(field).$touch();
                    if (this.getValidationField(field).$error) {
                        if (!this.errors.some(el => el.field === field)) {
                            this.errors.push({'field': field, 'message': null});
                        }
                    } else {
                        this.errors = this.errors.filter(el => el.field !== field);
                    }
                } catch (error) {}
            },
            reload() {
                window.location = '';
            },
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FSR') === -1) {
                this.$router.push('/');
                return;
            }
            
            if (this.$route.name === 'fire-stopping-report-edit-site-plan') {
                this.isEdit = true;
            }
            
            if (!this.isEdit) {
                this.getFireStoppingReport();
            } else {
                this.getSitePlan();
            }
        }
    }
</script>

<style scoped>
    form {
        margin-bottom: 2rem;
    }

    [class*='-message'] {
        font-weight: 500;
    }

    .has-error {
        border: 1px solid #d33c40;
    }

    .error-message {
        color: #d33c40;
    }

    .success-message {
        color: #32a95d;
    }
</style>